import { render } from "./BOToolkitDownload.vue?vue&type=template&id=78ce0d33&scoped=true"
import script from "./BOToolkitDownload.vue?vue&type=script&lang=js"
export * from "./BOToolkitDownload.vue?vue&type=script&lang=js"

import "./BOToolkitDownload.vue?vue&type=style&index=0&id=78ce0d33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ce0d33"]])

export default __exports__